import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { sendSmsVerification, verifySmsCode, backToMobileStep, jumpToVerifyStep, createTUCustomer } from "../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, sendSmsVerification.success, function (state, payload, meta) {
  return _objectSpread(_objectSpread({}, state), {}, {
    mobileNumber: meta.mobileNumber,
    smsCodeStep: true
  });
}), _defineProperty(_createReducer, sendSmsVerification.fail, function (state, payload) {
  var smsCodeStep = state.smsCodeStep,
      successfullyVerified = state.successfullyVerified;

  if (_get(payload, 'data.error.data.internal_message') === 'phone number associated with identity is already verified') {
    smsCodeStep = true;
    successfullyVerified = true;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: smsCodeStep,
    successfullyVerified: successfullyVerified
  });
}), _defineProperty(_createReducer, verifySmsCode.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    successfullyVerified: true
  });
}), _defineProperty(_createReducer, verifySmsCode.fail, function (state) {
  return _objectSpread({}, state);
}), _defineProperty(_createReducer, backToMobileStep, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: false
  });
}), _defineProperty(_createReducer, jumpToVerifyStep, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    smsCodeStep: true
  });
}), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  var internal_message = payload.internal_message,
      phone_number = payload.phone_number,
      require_sms = payload.require_sms;
  var smsVerificationRequired = require_sms || internal_message === 'User requires SMS verification';
  return _objectSpread(_objectSpread({}, state), {}, {
    verificationRequired: smsVerificationRequired,
    mobileNumber: phone_number
  });
}), _createReducer), {});